/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Add_ButtonInputs */

const en_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const fr_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const it_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungere`)
};

const ru_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлять`)
};

const es_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const zh_cn2_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const ja_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const hi_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ना`)
};

const pt_pt2_options_metadata_add_button = /** @type {(inputs: Options_Metadata_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Options_Metadata_Add_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_add_button = /** @type {((inputs?: Options_Metadata_Add_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Add_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_add_button(inputs)
	if (locale === "de") return de_options_metadata_add_button(inputs)
	if (locale === "it") return it_options_metadata_add_button(inputs)
	if (locale === "ru") return ru_options_metadata_add_button(inputs)
	if (locale === "es") return es_options_metadata_add_button(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_add_button(inputs)
	if (locale === "ja") return ja_options_metadata_add_button(inputs)
	if (locale === "hi") return hi_options_metadata_add_button(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_add_button(inputs)
	return en_options_metadata_add_button(inputs)
});